import React from 'react';
import { Box, Card, Typography, Button } from '@mui/material';
import meestLogo from '../../assets/logoNew.svg';
import notFoundLogo from '../../assets/notFoundLogo.png';
import { useNavigate } from 'react-router-dom';

const SessionExpired = ({ sessionData }) => {
    const navigate = useNavigate();

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100vh"
            bgcolor="#f5f5f5"
        >
            <Box
                style={{
                    width: '460px',
                    height: '150px',
                    backgroundColor: '#005096',
                    position: 'absolute',
                    top: 0,
                }}
            />
            <Card
                style={{
                    width: 420,
                    height: '94%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    borderRadius: '15px',
                    padding: '20px',
                    zIndex: 10,
                }}
            >
                <Box display="flex" justifyContent="center" mt={2} mb={30}>
                    <img src={meestLogo} alt="Meest Logo" style={{ height: '40px' }} />
                </Box>
                <Box display="flex" justifyContent="center" mb={4}>
                    <img src={notFoundLogo} alt="Not Found Logo" style={{ height: '120px' }} />
                </Box>
                <Box width="300px" mb={3} >
                    <Typography variant="body1" color="textSecondary" align="center" fontSize={18}>
                        Ваша сесія оплати закінчилась, повторіть пошук посилки по номеру.
                    </Typography>
                </Box>
                <Button variant="contained" fullWidth sx={{ backgroundColor: '#0061AF', color: '#fff', height: '48px' }} onClick={() => navigate('/')}
                >
                    Пошук посилки
                </Button>
            </Card>
        </Box>
    );
};

export default SessionExpired;
